import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import {LevelAKnowledgeDefinitionText} from "../../texts/levelAScreen/LevelAKnowledgeDefinitionText";
import LevelAQuestionButton from "../../buttons/levelAScreen/LevelAQuestionButton";
import {useState} from "react";
import LevelACardHeaderText from "../../texts/levelAScreen/LevelACardHeaderText";
import LevelAKnowledgeSticker from "../../stickers/levelAScreen/LevelAKnowledgeSticker";
import LevelAKnowledgeExplanationDialog from "../../dialogs/levelAScreen/LevelAKnowledgeExplanationDialog";

export default function LevelAKnowledge({levelAKnowledge, isBrevetDisplay}) {
    // Used in LevelACoreContent to display LevelA Knowledge
    // related info

    // PROPERTIES
    // ---- Modal
    const [isModalOpen, setIsModalOpen] = useState(false)
    // ---- Knowledge
    const knowledgeType = get_nested(['type'], levelAKnowledge, null)
    const knowledgeDefinition = get_nested(['definition'], levelAKnowledge, null)

    // BUILD
    if (isNullOrUndefined(levelAKnowledge) || isNullOrUndefined(knowledgeDefinition))
        return null
    return (
        <div className={"mt-[24px] bg-primaryDark4/20 border-[1px] border-greyLight3 w-full flex flex-col justify-start items-start px-[16px] py-[16px] rounded-[12px]"}>
            {/** MODAL */}
            <LevelAKnowledgeExplanationDialog open={isModalOpen}
                                              handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"w-full flex justify-between items-center"}>
                <div className={"flex justify-start items-center space-x-[8px]"}>
                    <LevelACardHeaderText text={"1. Ce que je dois mémoriser"} />
                    <LevelAQuestionButton onClick={processModalOpening} />
                </div>
                <LevelAKnowledgeSticker knowledgeType={knowledgeType}
                                        knowledgeDefinition={knowledgeDefinition}
                                        isBrevetDisplay={isBrevetDisplay} />
            </div>
            <SystemCustomDivider color={"bg-greyLight3"}
                                 extraClass={"mt-[16px]"} />
            <LevelAKnowledgeDefinitionText knowledgeDefinition={knowledgeDefinition} />
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}